import { PricingBreakdown } from '@cpak/adp-cpak-pricing-service-shared';

export interface PricingAnalysisTableValue {
  name: string;
  id?: string;
  quantity?: number;
  catalogNumber?: string;
  partNumber?: string;
  partStatus?: number | null;
  base?: number;
  summaryCost?: number;
  franchiseMsp?: number;
  landedMsp?: number;
  countryMsp?: number;
  levels?: number[];
  listMinus?: number;
  mspPlus?: number;
  price?: number;
  salesRep?: number;
  locationId?: string;
  allowedLocations?: string[];
  itemImage?: string;
  quantityOperatorDisabled?: boolean;
}

export interface PricingAnalysisTable {
  id: string;
  label: string;
  value: PricingAnalysisTableValue[];
  total?: PricingAnalysisTableValue;
  expandState: boolean;
}

export interface Levels {
  level1?: string;
  level2?: string;
  level3?: string;
  level4?: string;
  level5?: string;
  level6?: string;
  level7?: string;
}

export const PRICING_BREAKDOWN_NUMERIC_FIELDS: (keyof PricingBreakdown<number>)[] = [
  'base',
  'summaryCost',
  'franchiseMsp',
  'landedMsp',
  'countryMsp',
  'listMinus',
  'mspPlus',
  'price',
];

export interface PricingViewTable extends PricingAnalysisTableValue, Levels {}
